import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Header.css';

const Header = ({ user, setUser }) => {
  const [menuOpen, setMenuOpen] = useState(false); // Стан для гамбургер-меню
  const navigate = useNavigate();

  const handleLogout = () => {
    setUser(null); // Очищаємо інформацію про користувача
    navigate('/'); // Перенаправляємо на сторінку входу
  };

  return (
    <header className="menu">
      <div className="menu-header">
    
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
         {menuOpen? 'X': '☰'} 
        </button>
        </div>
      <div className="menu-container">
        <nav className={`menu-content ${menuOpen ? 'open' : ''}`}>
          <ul className="menu-left">
            <li><Link to="/create">Створити проєкт</Link></li>
            <li><Link to="/my-projects">Мої проєкти</Link></li>
            <li><Link to="/about">Про платформу</Link></li>
          </ul>
        </nav>
        <div className="menu-right">
          {user && <span className="user-name">Привіт, {user}!</span>}
          <button onClick={handleLogout} className="logout-button">{user? 'Вийти':'Вхід'}</button>
        </div>
      </div>
     
    </header>
  );
};

export default Header;